import { InjectionToken, FactoryProvider } from '@angular/core';

export interface DefaultThemeOptions {
  backgroundColor: string;
  header1Color: string;
  header2Color: string;
  header3Color: string;
  estimatedWaitColor: string;
  footerColor: string;
  bodyColor: string;
  tableHeaderColor: string;
  addButtonBackgroundColor: string;
  addButtonColor: string;
  formBackgroundColor: string;
  highlightColor: string;
}

export const DEFAULT_THEME = new InjectionToken<DefaultThemeOptions>('Default Theme');

export const defaultThemeProvider: FactoryProvider = {
  provide: DEFAULT_THEME,
  useFactory: (): DefaultThemeOptions => {
    return {
      backgroundColor: '#191c37',
      header1Color: '#ffffff',
      header2Color: '#ffffff',
      header3Color: '#ffffff',
      estimatedWaitColor: '#ffffff',
      footerColor: '#ffffff',
      bodyColor: '#191c37',
      tableHeaderColor: '#191c37',
      addButtonBackgroundColor: '#2daf17',
      addButtonColor: '#ffffff',
      formBackgroundColor: '#ffffff',
      highlightColor: '#c1c3d3',
    };
  },
};
